export default [
    '3dm',
    '3ds',
    '7z',
    'aco',
    'aep',
    'afm',
    'ai',
    'ait',
    'apk',
    'ard',
    'arw',
    'asc',
    'ase',
    'asp',
    'aspx',
    'avi',
    'blend',
    'bmml',
    'bmp',
    'c',
    'c4d',
    'cdr',
    'cdt',
    'cmx',
    'cpt',
    'cr2',
    'css',
    'csv',
    'd',
    'db',
    'des',
    'dfont',
    'dmg',
    'dng',
    'doc',
    'docm',
    'docx',
    'dot',
    'dotx',
    'dpp',
    'dst',
    'dwg',
    'dxf',
    'easm',
    'emb',
    'emf',
    'eml',
    'eot',
    'eps',
    'epub',
    'f',
    'fbx',
    'fh11',
    'fig',
    'fla',
    'flv',
    'fmv',
    'gdoc',
    'gif',
    'gsheet',
    'gz',
    'h',
    'hqx',
    'htm',
    'html',
    'icc',
    'icm',
    'icns',
    'ico',
    'icon',
    'idml',
    'igs',
    'indd',
    'indt',
    'inx',
    'jfif',
    'jp2',
    'jpe',
    'jpeg',
    'jpg',
    'js',
    'json',
    'key',
    'l',
    'la',
    'lmk',
    'log',
    'lst',
    'm',
    'm4a',
    'm4v',
    'mac',
    'max',
    'mb',
    'md',
    'mht',
    'mhtml',
    'mobi',
    'mov',
    'mp3',
    'mp4',
    'mpg',
    'msg',
    'mtl',
    'muse',
    'n',
    'nef',
    'net',
    'obj',
    'odg',
    'odp',
    'ods',
    'odt',
    'oft',
    'orf',
    'otf',
    'p7s',
    'pages',
    'pct',
    'pdf',
    'pdn',
    'pes',
    'pfb',
    'pfi',
    'pfm',
    'php',
    'php5',
    'png',
    'pot',
    'potm',
    'potx',
    'pps',
    'ppsx',
    'ppt',
    'pptm',
    'pptx',
    'ps',
    'psb',
    'psd',
    'pub',
    'pxm',
    'qxp',
    'r',
    'ra',
    'rar',
    'raw',
    'rp',
    'rtf',
    'saf',
    'scss',
    'sketch',
    'skp',
    'sldasm',
    'sldprt',
    'sm',
    'snag',
    'sql',
    'step',
    'stl',
    'stp',
    'svg',
    'svgz',
    'swf',
    'tar',
    'thmx',
    'tif',
    'tiff',
    'ttc',
    'ttf',
    'txt',
    'url',
    'v',
    'vcf',
    'vp',
    'vsd',
    'vsdx',
    'wav',
    'webloc',
    'webp',
    'wmf',
    'wmv',
    'woff',
    'woff2',
    'wps',
    'xaml',
    'xar',
    'xcf',
    'xd',
    'xlf',
    'xls',
    'xlsm',
    'xlsx',
    'xltx',
    'xml',
    'xps',
    'xsl',
    'y',
    'zip',
    'zipx',
];
